import script from "./ManagerViewAllGroupTalks.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerViewAllGroupTalks.vue?vue&type=script&setup=true&lang=js"

import "./ManagerViewAllGroupTalks.vue?vue&type=style&index=0&id=957e0b92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-957e0b92"]])

export default __exports__